import { Button, Form, Input, notification } from 'antd';
import { useFormik, useFormikContext } from 'formik';
import { rest } from 'lodash';
import { SparingRequestPayload } from 'models/SparingRequests';
import * as yup from 'yup';
import { FormLabel } from '../FormItems/FormLabel';

const subscribeSchema = yup.object({
  email: yup.string().label('Subscriber Email').email()
});

export const SubscribeInput = (): JSX.Element => {
  const { setFieldValue, values: contextValues } = useFormikContext<SparingRequestPayload>();

  const { touched, values, handleBlur, handleChange, errors, handleSubmit, setFieldTouched } = useFormik({
    validationSchema: subscribeSchema,
    initialValues: {
      email: ''
    },
    onSubmit: async ({ email }, { resetForm }) => {
      if (!email) return;

      if (contextValues.notificationEmails.includes(email))
        return notification.error({
          message: 'Error',
          description: 'Email already exists in the list',
          className: 'custom-class',
          style: {
            width: 600
          },
          duration: 5
        });
      setFieldValue('notificationEmails' as keyof SparingRequestPayload, [...contextValues.notificationEmails, email]);
      resetForm();
    }
  });

  const handleEnterPressed = (): void => {
    if (!errors.email) {
      handleSubmit();
    }
  };

  return (
    <Form.Item
      labelAlign="left"
      validateStatus={touched.email ? 'error' : 'success'}
      label={<FormLabel label="Subscriber Email" />}
      help={touched.email ? errors.email : undefined}
      style={{ marginBottom: 0 }}>
      <Input.Group style={{ display: 'flex' }} compact>
        <Input
          {...rest}
          onPressEnter={handleEnterPressed}
          value={values.email || undefined}
          onFocus={() => setFieldTouched('email', false)}
          onChange={handleChange('email')}
          onBlur={() => setFieldTouched('email', true)}
          style={{ flex: 1 }}
        />
        <Button type="primary" disabled={Boolean(errors.email || !values.email)} onClick={(): void => handleSubmit()}>
          Add
        </Button>
      </Input.Group>
    </Form.Item>
  );
};
